import shareme1 from "../assets/shareme1.png";
import shareme2 from "../assets/shareme2.png";
import shareme3 from "../assets/shareme3.png";

import viasat1 from "../assets/viasat1.png";
import viasat2 from "../assets/viasat2.png";
import viasat3 from "../assets/viasat3.png";

import streamOn from "../assets/streamOn.png";
import streamOn2 from "../assets/streamOn2.png";
import streamOn3 from "../assets/streamOn3.png";

import corea1 from "../assets/corea1.png";
import corea2 from "../assets/corea2.png";
import corea3 from "../assets/corea3.png";
import corea4 from "../assets/corea4.png";
import corea5 from "../assets/corea5.png";

import carolineseiffert1 from "../assets/carolineseiffert1.png";
import carolineseiffert2 from "../assets/carolineseiffert2.png";

import aiJs from "../assets/ai-js.png";
import aiJs2 from "../assets/ai-js2.png";

import car1 from "../assets/car1.png";
import car2 from "../assets/car2.png";
import car3 from "../assets/car3.png";
import car4 from "../assets/car4.png";
import car5 from "../assets/car5.png";

import home from "../assets/home.png";
import billing from "../assets/billing.png";
import help from "../assets/help.png";
import plan from "../assets/plan.png";
import review from "../assets/review.png";
import settings from "../assets/settings.png";
import usage from "../assets/usage.png";
import stream from "../assets/myviasat-stream.png";

import cumparaturii from "../assets/cumparaturii.png";

const ProjectsData = [
  {
    title: "Corea-auto",
    startDate: "Contractor",
    description:
      "Corea Auto stands as a premier car dealership located in the upper echelon of South Korea, offering a comprehensive online platform where users can conveniently browse through an extensive inventory of vehicles. From the latest models to pre-owned classics, our website provides detailed information on available cars, allowing users to explore various makes, models, and specifications. Whether you're in search of a sleek sedan, a rugged SUV, or a luxurious coupe, Corea Auto's website serves as your go-to destination for discovering the perfect vehicle to suit your needs. With user-friendly navigation and informative listings, finding your dream car has never been easier. Explore our selection, compare features, and embark on your journey towards automotive excellence with Corea Auto.",
    translation:
      "Corea Auto este un dealer auto de prim rang situat în eșalonul superior al Coreei de Sud, oferind o platformă online cuprinzătoare în care utilizatorii pot naviga în mod convenabil printr-un inventar extins de vehicule. De la cele mai recente modele până la modele clasice, site-ul nostru oferă informații detaliate despre mașinile disponibile, permițând utilizatorilor să exploreze diverse mărci, modele și specificații. Fie că sunteți în căutarea unui sedan elegant, a unui SUV robust sau a unui coupe luxos, site-ul web Corea Auto vă servește drept destinație de destinație pentru a descoperi vehiculul perfect pentru nevoile dumneavoastră. Cu navigare ușor de utilizat și listări informative, găsirea mașinii tale de vis nu a fost niciodată mai ușoară. Explorați selecția noastră, comparați caracteristicile și porniți-vă în călătoria către excelența auto cu Corea Auto.",
    images: [corea5, corea2, corea3, corea4, corea1],
    url: "https://www.corea-auto.com/",
    technologies: [
      {
        class: "devicon-react-original",
        name: "React",
      },
      {
        class: "devicon-typescript-plain",
        name: "TypeScript",
      },
      {
        class: "devicon-redux-plain",
        name: "redux",
      },
    ],
  },

  {
    title: "Social Media App",
    startDate: "Freelance",
    description:
      "Developed a user-friendly web application for social media engagement, enabling users to share their daily experiences and interact with each other's posts. Implemented a comprehensive user preference tracking system using localStorage, ensuring seamless retention of user activity and preferences across sessions. Users can effortlessly react to posts, fostering a dynamic and engaging community atmosphere. Leveraging localStorage facilitates a personalized user experience by enabling users to easily access their activity history and interactions with posts, thereby enhancing overall user satisfaction and platform usability.",
    translation:
      "A dezvoltat o aplicație web ușor de utilizat pentru implicarea în rețelele sociale, permițând utilizatorilor să-și împărtășească experiențele zilnice și să interacționeze cu postările celuilalt. Implementarea unui sistem cuprinzător de urmărire a preferințelor utilizatorilor folosind localStorage, asigurând reținerea fără probleme a activității și preferințelor utilizatorilor în sesiuni. Utilizatorii pot reacționa fără efort la postări, promovând o atmosferă de comunitate dinamică și captivantă. Folosirea localStorage facilitează o experiență personalizată a utilizatorului, permițând utilizatorilor să acceseze cu ușurință istoricul activității și interacțiunile cu postările, sporind astfel satisfacția generală a utilizatorilor și gradul de utilizare al platformei.",
    images: [shareme1, shareme2, shareme3],
    url: "https://share-me-elyesbk.netlify.app/login",
    technologies: [
      {
        class: "devicon-react-original",
        name: "React",
      },
      {
        class: "devicon-javascript-plain",
        name: "JavaScript",
      },
      {
        class: "devicon-tailwindcss-plain",
        name: "TailwindCss",
      },
    ],
  },
  {
    title: "My Viasat",
    startDate: "Contractor",
    description:
      "My viasat customer billing application and usage track view for myViasat user in order to buy , get billing and other features can use in order to reach the best user experience.",
    translation:
      "Aplicația de facturare a clienților Viasat și vizualizarea urmăririi utilizării pentru utilizatorul myViasat pentru a cumpăra, obține facturare și alte funcții pe care le pot folosi pentru a obține cea mai bună experiență de utilizator.",
    images: [
      home,
      billing,
      usage,
      plan,
      review,
      help,
      settings,
      viasat2,
      viasat1,
      viasat3,
    ],
    url: "https://www.viasat.com/",
    technologies: [
      {
        class: "devicon-react-plain",
        name: "React",
      },
      {
        class: "devicon-typescript-plain",
        name: "TypeScript",
      },
      {
        class: "devicon-graphql-plain",
        name: "GraphQl",
      },
      {
        class: "devicon-redux-plain",
        name: "Redux",
      },
    ],
  },
  {
    title: "Viasat StreamOn",
    startDate: "Contractor",
    description:
      "My viasat customer billing application and usage track view for myViasat user in order to buy , get billing and other features can use in order to reach the best user experience.",
    translation:
      "Aplicația de facturare a clienților Viasat și vizualizarea urmăririi utilizării pentru utilizatorul myViasat pentru a cumpăra, obține facturare și alte funcții pe care le pot folosi pentru a obține cea mai bună experiență de utilizator.",
    images: [stream, streamOn, streamOn2, streamOn3],
    url: "https://www.viasatsavings.com/satellite-internet/streaming/",
    technologies: [
      {
        class: "devicon-react-plain",
        name: "React",
      },
      {
        class: "devicon-typescript-plain",
        name: "TypeScript",
      },
      {
        class: "devicon-graphql-plain",
        name: "GraphQl",
      },
      {
        class: "devicon-redux-plain",
        name: "Redux",
      },
    ],
  },
  {
    title: "Caroline Seiffert",
    startDate: "Freelance",
    description:
      "Website for Caroline Seiffert ― a visual artist whose skill-on photographs are still life compositions of found everyday objects and all their surroundings. They arise from a natural flow of intuition and an open-hearted view.",
    translation:
      "Site-ul web pentru Caroline Seiffert – o artistă vizuală ale cărei fotografii cu pricepere sunt compoziții de natură moartă a obiectelor de zi cu zi găsite și a tuturor împrejurimilor lor. Ele apar dintr-un flux natural de intuiție și o vedere cu inima deschisă.",
    images: [carolineseiffert1, carolineseiffert2],
    url: "https://www.carolineseiffert.com/",
    technologies: [
      {
        class: "devicon-react-plain",
        name: "React",
      },
      {
        class: "devicon-typescript-plain",
        name: "TypeScript",
      },
      {
        class: "devicon-graphql-plain",
        name: "GraphQl",
      },
      {
        class: "devicon-redux-plain",
        name: "Redux",
      },
    ],
  },
  {
    title: "Javascript AI",
    startDate: "AI",
    description:
      "AI platform helps Js developers for fast and robust delivery in their daily tasks.",
    translation:
      "Platforma AI îi ajută pe dezvoltatorii Js pentru livrare rapidă și robustă în sarcinile lor zilnice.",
    images: [aiJs, aiJs2],
    url: "https://github.com/ElyesBenKhoud/Javascript-Bot-AI",
    technologies: [
      {
        class: "devicon-react-plain",
        name: "React",
      },
      {
        class: "devicon-javascript-plain",
        name: "Javascript",
      },
      {
        class: "devicon-bootstrap-plain",
        name: "Bootstrap",
      },
    ],
  },

  {
    title: "SaaS Rent Car",
    startDate: "Freelance ",
    description:
      "Rent Car platform showcase using Rapid API and set for using in real life with backend interaction and dashboard admin handling all data displayed within the UI.",
    translation:
      "Prezentare platformă Rent Car folosind Rapid API și setată pentru utilizare în viața reală, cu interacțiunea backend și administratorul tabloului de bord care gestionează toate datele afișate în interfața de utilizare.",
    images: [car1, car2, car3, car4, car5],
    url: "https://saas-rent-car.vercel.app/",
    technologies: [
      {
        class: "devicon-react-plain",
        name: "React",
      },
      {
        class: "devicon-nextjs-plain",
        name: "NextJs",
      },
      {
        class: "devicon-typescript-plain",
        name: "Typescript",
      },
      {
        class: "devicon-tailwindcss-plain",
        name: "TailwindCSS",
      },
    ],
  },
  {
    title: "Cumparaturi shopping app",
    startDate: "Personal - Learning ",
    description:
      "Shopping app implemented in order to learn VueJs while remained for the daily use as a shopping app list.",
    translation:
      "Aplicația de cumpărături implementată pentru a învăța VueJ-urile rămânând în același timp pentru utilizarea zilnică ca listă de aplicații de cumpărături.",
    images: [cumparaturii],
    url: "https://cumparaturi-ben-khoud.netlify.app/",
    technologies: [
      {
        class: "devicon-vuejs-plain",
        name: "VueJs",
      },
    ],
  },
];

export default ProjectsData;
